
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M375.71 356.744c-1.79-2.27-44.687-55.622-119.71-55.622s-117.92 53.351-119.71 55.622l31.42 24.756c.318-.404 32.458-40.378 88.29-40.378 55.147 0 87.024 38.807 88.354 40.458l-.064-.08 31.42-24.756z"}}),_c('path',{attrs:{"d":"M437.02 74.98C388.667 26.629 324.38 0 256 0S123.333 26.629 74.98 74.98C26.629 123.333 0 187.62 0 256s26.629 132.668 74.98 181.02C123.333 485.371 187.62 512 256 512s132.667-26.629 181.02-74.98C485.371 388.668 512 324.38 512 256s-26.629-132.667-74.98-181.02zM256 472c-119.103 0-216-96.897-216-216S136.897 40 256 40s216 96.897 216 216-96.897 216-216 216z"}}),_c('circle',{attrs:{"cx":"168","cy":"180.12","r":"32"}}),_c('circle',{attrs:{"cx":"344","cy":"180.12","r":"32"}})])
          )
        }
      }
    